'use strict';

var _ = require('lodash');

/**
 * Flight Analysis - Segment Class tab (select a row in Cabin view) - Post Departure Mode - Grid
 */
var FlightSegmentGridPostDepartureTransformerFactory = function FlightSegmentGridPostDepartureTransformerFactory(DataTransformer, momentService) {
  function FlightSegmentGridPostDepartureTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'segment-classes-post-departure';
    this.targetType = 'segment-flight-analysis-post-departure';
    this.priority = 1;
  }
  FlightSegmentGridPostDepartureTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightSegmentGridPostDepartureTransformer.constructor = FlightSegmentGridPostDepartureTransformer;
  FlightSegmentGridPostDepartureTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  FlightSegmentGridPostDepartureTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightSegmentGridPostDepartureTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  FlightSegmentGridPostDepartureTransformer.prototype.transform = function (data) {
    var memorizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var userSegmentTypes = {
      0: 'BOTH',
      1: 'LOCAL',
      2: 'CONNECT',
      get: function get(key) {
        return this[key] || this[0];
      }
    };
    var transformData = function transformData(segmentClasses) {
      var result = [];
      for (var i = 0, length = segmentClasses.length; i < length; i++) {
        var entry = segmentClasses[i];
        var segmentDepartureDateMoment = memorizedMomentOfDepartureDate(entry.segmentDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var flightDepartureDateMoment = memorizedMomentOfDepartureDate(entry.flightDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var newEntry = {
          entryKey: entry.carrier + entry.segment + entry.flightNumber + entry.flightDepartureDate + entry.segmentClass + entry.segmentId,
          flightId: entry.flightId,
          segmentId: entry.segmentId,
          segmentClassId: entry.segmentClassId,
          flightDepartureDate: entry.flightDepartureDate,
          carrier: entry.carrier,
          flightNumber: entry.flightNumber,
          opsSuffix: entry.opsSuffix,
          flightDepartureDateMoment: flightDepartureDateMoment,
          segmentDepartureDateMoment: segmentDepartureDateMoment,
          segment: entry.segment,
          segmentClass: entry.segmentClass,
          isSetAside: entry.setAside,
          waitList: entry.waitList,
          currentBookings: entry.currentBookings,
          currentGroupBookings: entry.currentGroupBookings,
          segmentLimitType: userSegmentTypes.get(entry.segmentLimitType),
          segmentLimitResSys: entry.segmentLimitResSys,
          segmentClassDisplaySeq: entry.segmentClassDisplaySeq,
          //post departure
          totalBoarding: entry.totalBoarding,
          trafficTotal: entry.trafficTotal,
          noShow: entry.noShow,
          groupNoShow: entry.groupNoShow,
          deniedBoarding: entry.deniedBoarding,
          upgradeInto: entry.upgradeInto,
          upgradeOut: entry.upgradeOut,
          downgradeInto: entry.downgradeInto,
          downgradeOut: entry.downgradeOut,
          misConnect: entry.misConnect,
          standByTotal: entry.standByTotal,
          revenueStandBy: entry.revenueStandBy,
          nonRevenueStandBy: entry.nonRevenueStandBy
        };
        result.push(newEntry);
      }
      return result;
    };
    return transformData(data.domain.segmentClasses || data.domain.results);
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  return FlightSegmentGridPostDepartureTransformer;
};
FlightSegmentGridPostDepartureTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = FlightSegmentGridPostDepartureTransformerFactory;